var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-textarea',{attrs:{"placeholder":_vm.placeholder,"value":_vm.content,"required":_vm.required},on:{"input":_vm.onValueChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }